export const dealersRolesSubMenu = [{
  path: '/dealers-roles/list',
  component: () => import('@/views/dealers-roles/list.vue'),
  name: 'dealerManagement.dealersRoles.title',
  meta: {
    roles: ['Super Admin', 'Admin'],
    title: 'dealerManagement.dealersRoles.title',
    icon: 'user',
    noCache: true
  }
}, {
  path: '/dealers-roles/add',
  component: () => import('@/views/dealers-roles/manage.vue'),
  name: 'dealerManagement.dealersRoles.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'dealerManagement.dealersRoles.add',
    noCache: true,
    activeMenu: '/users/list',
    hidden: true
  }
}, {
  path: '/dealers-roles/edit/:id(\\d+)',
  component: () => import('@/views/dealers-roles/manage.vue'),
  name: 'dealerManagement.dealersRoles.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'dealerManagement.dealersRoles.edit',
    noCache: true,
    activeMenu: '/users/list',
    hidden: true
  }
}];